import React from 'react';
import { DrillIcon, RefreshCwIcon, WrenchIcon } from 'lucide-react';
import { services } from '../../data/site';
const icons = {
  wrench: WrenchIcon,
  drill: DrillIcon,
  refresh: RefreshCwIcon
};
export function Services() {
  return <section id="opgaver" className="scroll-mt-24" data-id="element-171" data-mp="dj6ncvr9ixvn">
      <div className="mx-auto max-w-content px-5 py-16 md:py-24 lg:px-8" data-id="element-172" data-mp="ibzv7si12mby">
        <h2 className="max-w-2xl font-display text-[clamp(2rem,5.5vw,3.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-173" data-mp="idavhic9lbyb">
          Hvad kan jeg hjælpe med?
        </h2>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-174" data-mp="s7t6z9nxabso">
          {services.map(service => {
          const Icon = icons[service.icon];
          return <li key={service.title} className="flex h-full flex-col rounded-card border border-line bg-white p-7 transition-[box-shadow,border-color,transform] duration-300 ease-smooth hover:-translate-y-1 hover:border-ink/15 hover:shadow-card" data-id="element-175" data-mp="1199g7e3047vb">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-line bg-canvas text-ink" data-id="element-176" data-mp="1os1vkxbx7w10">
                  <Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-177" data-mp="1jz0au8p1929i" />
                </span>
                <h3 className="mt-5 font-display text-2xl font-bold tracking-tight text-ink" data-id="element-178" data-mp="1fwlwo1wb6qok">
                  {service.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-179" data-mp="27q5vd15x4iq5">{service.description}</p>
              </li>;
        })}
        </ul>

        <p className="mt-8 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-180" data-mp="23mg8qh8t0b7r">
          Har du en opgave, der ikke passer ind i kategorierne?{' '}
          <a href="#kontakt" className="font-medium text-accent underline decoration-accent/30 underline-offset-4 transition-colors duration-200 ease-smooth hover:text-accent-deep" data-id="element-181" data-mp="1tp1t2jupfqgi">
            Kontakt mig alligevel
          </a>{' '}
          – så finder vi ud af, om jeg kan hjælpe.
        </p>
      </div>
    </section>;
}